import { createCompany, getCompanies } from "../api/companyService";

/**
 * Hook for creating a company and syncing with local state.
 * @param {Function} setCompanies - setter from useCompanies
 */
export const useCreateCompany = (setCompanies) => {
    const create = async (data) => {
        try {
            const newCompany = await createCompany(data);
            const companiesResponse = await getCompanies();
            setCompanies(companiesResponse);
            return newCompany;
        } catch (error) {
            console.error("Failed to create company:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};